import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import s from './SuperAdminLogin.module.css';

export default function SuperAdminLogin() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [view, setView] = useState('login');
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const handleLoginSubmit = (e) => {
    e.preventDefault();
    const correctUser = "Roomcardadmin";
    const correctPass = "TheHexaRoOmCArD";

    if (username === correctUser && password === correctPass) {
      setError('');
      localStorage.setItem("superAdminAuth", "true");
      localStorage.setItem("superAdminUser", username);
      navigate('/superadmin/dashboard', { replace: true });
    } else {
      setError('Invalid credentials. Access denied.');
      const form = document.getElementById('superAdminForm');
      if(form) {
        form.classList.add(s.shake);
        setTimeout(() => form.classList.remove(s.shake), 500);
      }
    }
  };

  return (
    <div className={s.wrapper}>
      <div className={s.blob}></div>
      <div className={s.blob}></div>
      <div className={s.gridOverlay}></div>

      <div className={s.card}>
        <div className={s.badgeTop}>
          <span className={s.badgeIcon}>🛡️</span>
          <span>Super Admin Portal</span>
        </div>

        <div className={s.cardHeader}>
          <div className={s.logoBox}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
              <path d="M9 12l2 2 4-4"/>
            </svg>
          </div>
          <h1 className={s.title}>Welcome, Admin</h1>
          <p className={s.subtitle}>Sign in to manage your RoomCard control panel</p>
        </div>

        {view === 'login' ? (
          <form id="superAdminForm" onSubmit={handleLoginSubmit} className={s.form}>
            {error && (
              <div className={s.errorBox}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <circle cx="12" cy="12" r="10"/>
                  <line x1="12" y1="8" x2="12" y2="12"/>
                  <line x1="12" y1="16" x2="12.01" y2="16"/>
                </svg>
                {error}
              </div>
            )}

            <div className={s.fieldGroup}>
              <label htmlFor="username" className={s.labelInput}>Admin Username</label>
              <div className={s.inputWrapper}>
                <svg className={s.icon} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                    d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                </svg>
                <input
                  id="username"
                  className={s.inputField}
                  type="text"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  placeholder="Enter admin username"
                  required
                  autoComplete="username"
                />
              </div>
            </div>

            <div className={s.fieldGroup}>
              <label htmlFor="password" className={s.labelInput}>Password</label>
              <div className={s.inputWrapper}>
                <svg className={s.icon} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                    d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                </svg>
                <input
                  id="password"
                  className={s.inputField}
                  type={showPassword ? "text" : "password"}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="••••••••"
                  required
                  autoComplete="current-password"
                />
                <button
                  type="button"
                  className={s.eyeBtn}
                  onClick={() => setShowPassword(!showPassword)}
                  tabIndex={-1}
                >
                  {showPassword ? "🙈" : "👁️"}
                </button>
              </div>
            </div>

            <button type="submit" className={s.btnPrimary}>
              <span>Access Dashboard</span>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <line x1="5" y1="12" x2="19" y2="12"/>
                <polyline points="12 5 19 12 12 19"/>
              </svg>
            </button>

            <div className={s.divider}><span>OR</span></div>

            <button
              type="button"
              onClick={() => setView('forgot')}
              className={s.linkButton}
            >
              Forgot Password?
            </button>
          </form>
        ) : (
          <div className={s.forgotContainer}>
            <div className={s.forgotIcon}>
               <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" width="48" height="48">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                  d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" />
              </svg>
            </div>
            <h3 className={s.forgotTitle}>Need Help?</h3>
            <p className={s.forgotText}>
              For super-admin password recovery, please contact your system administrator directly via WhatsApp.
            </p>
            <a
              href="https://wa.me/917092471686?text=Hello%2C%20I%20need%20help%20with%20Super%20Admin%20password%20reset."
              target="_blank"
              rel="noopener noreferrer"
              className={s.whatsappBtn}
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
              </svg>
              <span>Contact via WhatsApp</span>
            </a>
            <button
              type="button"
              onClick={() => {
                setView('login');
                setError('');
                setUsername('');
                setPassword('');
              }}
              className={s.backLink}
            >
              ← Back to Login
            </button>
          </div>
        )}

        <div className={s.footerText}>
          <p>🔒 Encrypted Secure Connection</p>
          <p className={s.brandName}>HexaPlay © Super Admin Panel</p>
        </div>
      </div>
    </div>
  );
}